import { Injectable } from '@angular/core'
import {
	AtylAdresse, AtylAgrement, AtylCheckbox, AtylDateRange, AtylDatetime,
	AtylDivider, AtylDropdown, AtylEmail, AtylLabel, AtylNumber, AtylRadio, AtylSignature, AtylTable, AtylTelephone, AtylText, AtylTextArea,AtylPlace
} from './atyl-input-components/atyl-input-components'
import { AtylList } from './atyl-input-components/atyl-list/atyl-list.component'
import { AtylSelectionList } from './atyl-input-components/atyl-selectionlist/atyl-selectionlist.component'
import { AtylSection, AtylSubSection } from './atyl-structure-components/atyl-structure.component'
import { FormAtylBase } from './form-atyl-base'

@Injectable()
export class FormAtylService {

	getAtylInputs(jsonAtylInputs: string,
			dossier?: any,
			tiers?: any,
	 ) {

		let atylInputs: FormAtylBase<any>[] = []
		let escapedJson = this.CheckJsonStruct(jsonAtylInputs)
		let objAtylInputs = JSON.parse(escapedJson)

		objAtylInputs.forEach(atylInput => {
			
			
			let aInput:any=this.SortInputAtyl(atylInput);
			aInput.dossier=dossier;
			aInput.tiers=tiers;
			atylInputs.push(aInput);
		})

		return atylInputs
	}

	SortInputAtyl(atylInputObj: any) {
		
		//console.log("SortInputAtyl",atylInputObj.field)
		
		switch (atylInputObj.field.type) {
			case 'text':
				{
					let atylText = new AtylText({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						options: atylInputObj.field.options,
						optionsDefault: atylInputObj.field.optionsDefault,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylText
				}
			case 'textarea':
				{
					let atylTextarea = new AtylTextArea({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						options: atylInputObj.field.options,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					})
					return atylTextarea
				}
			case 'number':
				{
					let atylNumber = new AtylNumber({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						options: atylInputObj.field.options,
						optionsDefault: atylInputObj.field.optionsDefault,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					})
					return atylNumber
				}
			case 'tel':
				{
					let atylTel = new AtylTelephone({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						options: atylInputObj.field.options,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					console.log("___tel",atylTel)
					return atylTel
				}
			case 'email':
				{
					let atylEmail = new AtylEmail({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylEmail
				}
			case 'dropdown':
				{
					let atylDropdown = new AtylDropdown({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						options: atylInputObj.field.options,
						optionsDefault: atylInputObj.field.optionsDefault,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylDropdown
				}
			case 'checkbox':
				{
					let atylCheckbox = new AtylCheckbox({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						options: atylInputObj.field.options,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylCheckbox
				}
			case 'radio':
				{
					let atylRadio = new AtylRadio({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						options: atylInputObj.field.options,
						optionsDefault: atylInputObj.field.optionsDefault,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					if (atylRadio.options && Array.isArray(atylRadio.options.values) && atylRadio.options.values) {
						atylRadio.options.values.forEach((element) => {
							element.value = String(element.value)
						})
					}
					return atylRadio
				}
			case 'date':
				{
					let atylDatetime = new AtylDatetime({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						options: atylInputObj.field.options,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylDatetime
				}
			case 'daterange':
				{
					let atylDaterange = new AtylDateRange({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						options: atylInputObj.field.options,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylDaterange
				}
			case 'section':
				{
					let tempChildren = []
					atylInputObj.children.forEach(element => {
						tempChildren.push(this.SortInputAtyl(element))
					})
					let atylSection = new AtylSection({
						key: atylInputObj.key,
						label: atylInputObj.label,
						type: atylInputObj.type,
						children: tempChildren,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
					})
					return atylSection
				}
			case 'subSection':
				{
					let tempChildren = []
					atylInputObj.children.forEach(element => {
						tempChildren.push(this.SortInputAtyl(element))
					})
					let atylSubSection = new AtylSubSection({
						key: atylInputObj.key,
						label: atylInputObj.label,
						type: atylInputObj.field.type,
						children: tempChildren,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
					})
					return atylSubSection
				}
			case 'divider':
				{
					let atylDivider = new AtylDivider({
						key: atylInputObj.key,
						label: atylInputObj.label,
						type: atylInputObj.field.type,
						structureType: 'input',
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
					})
					return atylDivider
				}
			case 'label':
				{
					let atylLabel = new AtylLabel({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						value: atylInputObj.value,
						type: atylInputObj.field.type,
						description: atylInputObj.field.description,
						options: atylInputObj.field.options,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
					})
					return atylLabel
				}
			case 'table':
				{
					let atylTable = new AtylTable({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						options: atylInputObj.field.options,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						order: atylInputObj.order,
						customBehaviour: atylInputObj.field.customBehaviour,
						type: atylInputObj.field.type,
						minRow: 5,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					if (atylInputObj.field.optionsDefault && atylInputObj.field.optionsDefault.minRow)
						atylTable.minRow = atylInputObj.field.optionsDefault.minRow
					atylTable = this.GeneratedTable(atylTable)
					return atylTable
				}
			case 'adresse':
				{
					let atylAdresse = new AtylAdresse({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						options: atylInputObj.field.options,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						customBehaviour: atylInputObj.field.customBehaviour,
						type: atylInputObj.field.type,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylAdresse
				}

			case 'selectionlist':
				{
					let atylSelectionList = new AtylSelectionList({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						options: atylInputObj.field.options,
						optionsDefault: atylInputObj.field.optionsDefault,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					})
					return atylSelectionList
				}

			case 'list': {
				let atylList = new AtylList({
					ID: atylInputObj.ID,
					key: atylInputObj.field.key,
					label: atylInputObj.field.label,
					value: atylInputObj.value,
					restrictions: atylInputObj.field.restrictions,
					order: atylInputObj.order,
					type: atylInputObj.field.type,
					customBehaviour: atylInputObj.field.customBehaviour,
					structureType: 'select',
					deepNested: atylInputObj.field.deepNested,
					placeholder: atylInputObj.field.placeholder,
					floatlabel: atylInputObj.field.floatlabel,
					options: atylInputObj.field.options,
					optionsDefault: atylInputObj.field.optionsDefault,
					observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
					observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
					historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
					readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
					hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
								
				})
				return atylList
			}
			case 'agrement':
				{
					let atylAgrement = new AtylAgrement({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						label: atylInputObj.field.label,
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						options: atylInputObj.field.options,
						optionsDefault: atylInputObj.field.optionsDefault,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylAgrement
				}
			case 'signature':
				{
					let atylSignature = new AtylSignature({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						options: atylInputObj.field.options,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
					
					})
					return atylSignature
				}	
			case "place":
		        {
		            let atylPlace = new AtylPlace({
						ID: atylInputObj.ID,
						key: atylInputObj.field.key,
						options: atylInputObj.field.options,
						label: atylInputObj.field.label,
						description: this.htmlToText(atylInputObj.field.description),
						value: atylInputObj.value,
						restrictions: atylInputObj.field.restrictions,
						mendatory: atylInputObj.mendatory,
						order: atylInputObj.order,
						type: atylInputObj.field.type,
						customBehaviour: atylInputObj.field.customBehaviour,
						structureType: 'input',
						deepNested: atylInputObj.field.deepNested,
						placeholder: atylInputObj.field.placeholder,
						floatlabel: atylInputObj.field.floatlabel,
						observe: atylInputObj.field.observe ? atylInputObj.field.observe : false,
						observe_champ: atylInputObj.observe_champ ? atylInputObj.observe_champ : 0,
						historique: atylInputObj.field.historique ? atylInputObj.field.historique : false,
						readonly: atylInputObj.field.read_only ? atylInputObj.field.read_only : false,
						hideCreate: atylInputObj.hide_create ? atylInputObj.hide_create : false,
		            });
		            return atylPlace;
		        }	
		}
	}
	GeneratedTable(baseComponent: any) {
		let table = baseComponent as AtylTable
		table.idColumns = []
		table.nameColumns = []
		table.rowControlers = []
		if (table.options && table.options.length > 0) {
			table.options.forEach((column, indexCol) => {
				table.nameColumns.push(column.label)
				table.idColumns.push(column.key)
			})

			table.rows = Array(table.minRow).fill([]).map((x, i) => [])
			table.rows.forEach((row, indexRow) => {
				table.options.forEach((column, indexCol) => {

					row[column.key] = { 'field': Object.assign({}, column) }

					if (indexCol === 0 && row[column.key].field.type === 'label' && row[column.key].field.options.values) {
						row[column.key].field.label = row[column.key].field.options.values[indexRow].label
					}
					row[column.key].ID = String(column.key + '_' + indexRow)
					row[column.key].deepNested = indexRow + '.' + table.ID + column.key + indexRow
					row[column.key].controler = this.SortInputAtyl(row[column.key])
					//if(row[column.key].type == 'checkbox' || row[column.key].type == 'radio')
					row[column.key].label = ''
				})
			})
		}
		return table
	}
	CheckJsonStruct(jsonToCheck: string) {
		if (jsonToCheck && jsonToCheck[0] == '[' && jsonToCheck[jsonToCheck.length - 1] == ']')
			return jsonToCheck
		else
			return '[]'
	}

	htmlToText(conv: string) {
		if (conv) {
			conv = conv.replace(/<style([\s\S]*?)<\/style>/gi, '')
			conv = conv.replace(/<script([\s\S]*?)<\/script>/gi, '')
			conv = conv.replace(/<\/div>/ig, '\n')
			conv = conv.replace(/<\/li>/ig, '\n')
			conv = conv.replace(/<li>/ig, '  *  ')
			conv = conv.replace(/<\/ul>/ig, '\n')
			conv = conv.replace(/<\/p>/ig, '\n')
			conv = conv.replace(/<br\s*[\/]?>/gi, '\n')
			conv = conv.replace(/<[^>]+>/ig, '')
		}
		return conv
	}
}
